import { render, staticRenderFns } from "./RoleGroupDetail.vue?vue&type=template&id=12b9506c"
import script from "./RoleGroupDetail.vue?vue&type=script&lang=ts"
export * from "./RoleGroupDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports